<script lang="ts" setup>
import type { ToasterProps } from "vue-sonner"
import { Toaster as Sonner } from "vue-sonner"

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--success-bg': 'var(--popover)',
      '--success-text': 'var(--chart-3)',
      '--success-border': 'var(--border)',
      '--error-bg': 'var(--popover)',
      '--error-text': 'var(--destructive)',
      '--error-border': 'var(--border)',
      '--info-bg': 'var(--popover)',
      '--info-text': 'var(--primary)',
      '--info-border': 'var(--border)',
      '--warning-bg': 'var(--popover)',
      '--warning-text': 'var(--chart-4)',
      '--warning-border': 'var(--border)',
    }"
  />
</template>
